import React from 'react';
import { Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { ServiceLayer } from '../services-layer-types';

export const itvPorTiLayer: ServiceLayer = {
	header: 'Servicios del taller',
	title: 'Pasamos la ITV por ti',
	subtitle: (
		<Text appearance={TokenTextAppearance.copy200}>
			Como sabemos que tu tiempo vale oro, si eres del Club Volkswagen puedes disfrutar de este servicio por solo 10€.
			En tu taller se encargarán de todo: recoger el coche en tu casa, llevarlo a pasar la ITV y devolvértelo una vez
			revisado. ¡Así de fácil!
		</Text>
	),
	imageFooter: 'https://assets.volkswagen.com/is/image/volkswagenag/layer-itv?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT01NDAmZm10PWpwZWcmcWx0PTc5JmJmYz1vZmYmMmFiZg==',
};
